// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.v-breadcrumbs{padding-top:0 !important;padding-bottom:0 !important;margin-bottom:0 !important}.v-breadcrumbs.v-breadcrumbs--density-default{flex-wrap:wrap !important;white-space:normal !important}`, "",{"version":3,"sources":["webpack://./lib/vue/breadcrumbs.vue"],"names":[],"mappings":"AACA,eACI,wBAAA,CACA,2BAAA,CACA,0BAAA,CAEJ,8CACE,yBAAA,CACA,6BAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
